import { useEffect, useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { Breakpoint, breakpoints } from '@theme/tokens';

const isMobile = (width: number) => width > breakpoints.mobile;
const isTablet = (width: number) => width > breakpoints.tablet;
const isDesktop = (width: number) => width > breakpoints.desktop;

export function useResponsiveValue(defaultBreakpoint: Breakpoint = 'mobile') {
  const { width } = useWindowDimensions();

  if (isDesktop(width)) {
    return 'desktop';
  }

  if (isTablet(width)) {
    return 'tablet';
  }

  if (isMobile(width)) {
    return 'mobile';
  }

  return defaultBreakpoint;
}

export function useResponsiveValueV2(defaultBreakpoint: Breakpoint = 'mobile') {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
  });

  if (isDesktop(width)) {
    return 'desktop';
  }

  if (isTablet(width)) {
    return 'tablet';
  }

  if (isMobile(width)) {
    return 'mobile';
  }

  return defaultBreakpoint;
}

export function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
  });

  return width;
}
